import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const entAjustesApi = `${baseUrl}/entidad-ajustes`;

export const saveEntAjustesService = async (data) => {
  const res = await axios.patch(entAjustesApi, data, { headers: token({}) });
  return res;
};

export const oneEntAjustesService = async (id) => {
  const res = await axios.get(`${entAjustesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
